import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, CTA_LABEL, trackInitiateCheckout } from './checkout';
import { packageIncludes } from './PricingSection';
const noMore = ['No more Sunday evenings searching for progressions that actually work', 'No more lessons that feel rushed or improvised', 'No more students losing motivation because sessions feel repetitive', 'No more weekends lost planning instead of living', 'No more walking into the arena wishing you had prepared more'];
const includes = [...packageIncludes, 'Immediate access', 'Pay in your local currency', 'PDF format ready to use'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-forest relative overflow-hidden" data-id="element-105" data-mp="qwgl4g7352zi">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-106" data-mp="14whk1q3si0cc">
        <div className="text-center mb-16" data-id="element-107" data-mp="zwd7uc9wzrrx">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-ivory" data-id="element-108" data-mp="zxo7bzwbudd8">
            Next Monday you can keep building your lessons from scratch...
            <br data-id="element-109" data-mp="2h37zj3peav1q" />
            <span className="text-gold" data-id="element-110" data-mp="2h4suuvjjai0n">
              Or you can walk into the arena with everything ready — from today.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-forest-dark p-8 rounded-2xl border border-ivory/10" data-id="element-111" data-mp="2r1xhsxl7ehii">
            {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-112" data-mp="2v38ww96gbkcg">
                <span className="text-gold mt-1" aria-hidden="true" data-id="element-113" data-mp="301u26n0k8u7r">
                  ▸
                </span>
                <span className="text-ivory/80" data-id="element-114" data-mp="34un4734n9og5">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-ivory mb-2" data-id="element-115" data-mp="39rvnx85fy0ji">
            Horse Riding Instructor Ready doesn't make you a better instructor.
          </p>
          <p className="text-2xl font-bold text-gold mb-6" data-id="element-116" data-mp="3it3c2xe8tkzv">
            You are already a great instructor.
          </p>
          <p className="text-xl text-ivory/80 mb-16" data-id="element-117" data-mp="1jnk082gt1kqj">
            What Horse Riding Instructor Ready does is give you a complete
            system — six volumes, one purchase, every stage covered — so that
            your skill as an instructor is visible in every single lesson you
            teach.
          </p>
        </div>

        <div className="bg-white border-2 border-gold rounded-3xl p-8 md:p-12 shadow-[0_16px_40px_rgba(0,0,0,0.2)]" data-id="element-118" data-mp="1nodpaz5zh5l0">
          <h3 className="text-2xl font-bold text-forest mb-6 text-center border-b border-gold-aged/40 pb-6 font-serif" data-id="element-119" data-mp="22gxojoq0isx6">
            Everything that's included in the complete 6-in-1 system:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-120" data-mp="2bd6nl2a2vpis">
            {includes.map(item => <div key={item} className="flex items-start gap-3" data-id="element-121" data-mp="h1i5wscgp8up">
                <Check size={18} className="text-pine shrink-0 mt-0.5" data-id="element-122" data-mp="h1rwoi5bzk1g" />
                <span className="text-sm text-ink" data-id="element-123" data-mp="d0y77kc8px6g">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-124" data-mp="2x9hhm9l9llj">
            <div className="mb-8 p-6 bg-cream rounded-xl border border-gold/40 italic text-ink text-lg" data-id="element-125" data-mp="6xjvnm7jbibh">
              “The best time to have this complete teaching system was before
              your very first riding lesson.
              <br data-id="element-126" data-mp="3u9uanroyidxo" />
              <span className="text-forest font-bold not-italic" data-id="element-127" data-mp="3u9cib65f0jv1">
                The second best time is today.
              </span>
              ”
            </div>

            <p className="text-xl font-serif font-bold text-forest mb-1" data-id="element-128" data-mp="3kczdbc4f6jkz">
              📚 Horse Riding Instructor Ready
            </p>
            <p className="text-base font-medium text-pine mb-2" data-id="element-129" data-mp="36dzy0v2srh1h">
              The Complete 6-in-1 Teaching System
            </p>
            <p className="text-sm text-warmgray mb-2" data-id="element-130" data-mp="3bdmedddx9dei">
              90 riding lessons across 6 progressive volumes — built to help
              instructors plan less, teach with confidence, and guide every
              rider from their very first approach to a horse all the way to
              developing rider independence.
            </p>
            <p className="text-sm font-bold text-forest mb-8" data-id="element-131" data-mp="30o6ti60u2omc">
              One system. Six volumes. Every stage covered.
            </p>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="w-full md:w-auto text-lg md:text-xl py-6 px-12 mb-6" data-id="element-132" data-mp="2vnk8kw3409d4">
              {CTA_LABEL}
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-warmgray" data-id="element-133" data-mp="2hx6yan2qwikm">
              <span data-id="element-134" data-mp="2czxcriih8r22">✅ 7-day money-back guarantee</span>
              <span data-id="element-135" data-mp="2cwjccftdirx9">✅ Secure payment</span>
              <span data-id="element-136" data-mp="280u6xvuoagt1">✅ Immediate access</span>
              <span data-id="element-137" data-mp="27xpxaiyfusuz">✅ Pay in your local currency</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}